import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Preloader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // 1 second
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#ffffff",
  };

  const imageStyle = {
    width: "350px",
    height: "auto",
  };

  return (
    <div style={loaderStyle}>
      <motion.img
        src="/images/icons/LOGO.png"
        alt="Loading..."
        style={imageStyle}
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default Preloader;
